/**
 * Carousel Big Title Block JavaScript
 */

(function () {
  "use strict";

  // Wait for GSAP to be available
  function checkGSAP() {
    let gsapLib = null;

    // Check multiple ways GSAP might be available
    if (typeof gsap !== "undefined") {
      gsapLib = gsap;
    } else if (typeof window.gsap !== "undefined") {
      gsapLib = window.gsap;
    } else if (window.SOJ_GSAP_ANIMATIONS && window.SOJ_GSAP_ANIMATIONS.gsap) {
      gsapLib = window.SOJ_GSAP_ANIMATIONS.gsap;
    }

    if (!gsapLib) {
      // Retry after a short delay if GSAP isn't loaded yet
      setTimeout(checkGSAP, 100);
      return;
    }

    // Initialize block functionality once GSAP is available
    initCarouselBigTitle(gsapLib);
  }

  // Initialize block functionality
  function initCarouselBigTitle(gsapLib) {
    const blocks = document.querySelectorAll(".stories");

    blocks.forEach((block) => {
      // Initialize accordion functionality
      const accordion = block.querySelector(".accordion");
      if (accordion) {
        initAccordion(accordion, gsapLib);
      }
    });
  }

  /**
   * Initialize accordion functionality with GSAP animations
   * @param {HTMLElement} accordion - The accordion container element
   * @param {Object} gsapLib - GSAP library instance
   */
  function initAccordion(accordion, gsapLib) {
    const accordionItems = accordion.querySelectorAll(".accordion_item");

    accordionItems.forEach((item) => {
      const title = item.querySelector(".accordion_title");
      const content = item.querySelector(".accordion_content");

      if (title && content) {
        // Store GSAP animation instance
        let animation = null;

        // Add click handler
        title.addEventListener("click", function () {
          const isActive = item.classList.contains("active");

          // Close all other items
          accordionItems.forEach((otherItem) => {
            if (otherItem !== item) {
              const otherContent =
                otherItem.querySelector(".accordion_content");
              const otherIsActive = otherItem.classList.contains("active");

              if (otherIsActive && otherContent) {
                // Kill any existing animation
                const otherAnimation = otherItem._gsapAnimation;
                if (otherAnimation) {
                  otherAnimation.kill();
                }

                // Get current height (in case it's set to auto)
                const currentHeight =
                  otherContent.offsetHeight || otherContent.scrollHeight;

                // Set to specific height first if it's auto
                if (
                  otherContent.style.height === "auto" ||
                  !otherContent.style.height
                ) {
                  gsapLib.set(otherContent, { height: currentHeight });
                }

                // Animate closed
                gsapLib.to(otherContent, {
                  height: 0,
                  opacity: 0,
                  paddingBottom: 0,
                  duration: 0.3,
                  ease: "power2.inOut",
                  onComplete: () => {
                    otherItem.classList.remove("active");
                  },
                });

                // Rotate cross icon back
                const otherCross = otherItem.querySelector(".cross");
                if (otherCross) {
                  const line1 = otherCross.querySelector(".line1");
                  const line2 = otherCross.querySelector(".line2");
                  if (line1) {
                    gsapLib.to(line1, {
                      rotation: 0,
                      transformOrigin: "50% 50%",
                      duration: 0.3,
                      ease: "power2.inOut",
                    });
                  }
                  if (line2) {
                    gsapLib.to(line2, {
                      rotation: 0,
                      transformOrigin: "50% 50%",
                      duration: 0.3,
                      ease: "power2.inOut",
                    });
                  }
                }
              }
            }
          });

          // Toggle current item
          if (isActive) {
            // Close current item
            // Get current height (in case it's set to auto)
            const currentHeight = content.offsetHeight || content.scrollHeight;

            // Set to specific height first if it's auto
            if (content.style.height === "auto" || !content.style.height) {
              gsapLib.set(content, { height: currentHeight });
            }

            // Kill any existing animation
            if (animation) {
              animation.kill();
            }

            // Animate closed
            gsapLib.to(content, {
              height: 0,
              opacity: 0,
              paddingBottom: 0,
              duration: 0.3,
              ease: "power2.inOut",
              onComplete: () => {
                item.classList.remove("active");
              },
            });

            // Rotate cross icon back
            const cross = item.querySelector(".cross");
            if (cross) {
              const line1 = cross.querySelector(".line1");
              const line2 = cross.querySelector(".line2");
              if (line1) {
                gsapLib.to(line1, {
                  rotation: 0,
                  transformOrigin: "50% 50%",
                  duration: 0.3,
                  ease: "power2.inOut",
                });
              }
              if (line2) {
                gsapLib.to(line2, {
                  rotation: 0,
                  transformOrigin: "50% 50%",
                  duration: 0.3,
                  ease: "power2.inOut",
                });
              }
            }
          } else {
            // Open current item
            item.classList.add("active");

            // Set initial state
            gsapLib.set(content, {
              height: 0,
              opacity: 0,
              paddingBottom: 0,
            });

            // Get the actual height by temporarily setting to auto
            const currentHeight = content.scrollHeight;

            // Animate open
            animation = gsapLib.to(content, {
              height: currentHeight,
              opacity: 1,
              paddingBottom: 20,
              duration: 0.3,
              ease: "power2.inOut",
              onComplete: () => {
                // Set to auto after animation completes for responsive behavior
                gsapLib.set(content, { height: "auto" });
              },
            });

            // Store animation for potential reversal
            item._gsapAnimation = animation;

            // Rotate cross icon
            const cross = item.querySelector(".cross");
            if (cross) {
              const line1 = cross.querySelector(".line1");
              const line2 = cross.querySelector(".line2");
              if (line1) {
                gsapLib.to(line1, {
                  rotation: 45,
                  transformOrigin: "50% 50%",
                  duration: 0.3,
                  ease: "power2.inOut",
                });
              }
              if (line2) {
                gsapLib.to(line2, {
                  rotation: 45,
                  transformOrigin: "50% 50%",
                  duration: 0.3,
                  ease: "power2.inOut",
                });
              }
            }
          }
        });
      }
    });
  }

  // Start checking for GSAP
  checkGSAP();
})();
